import { render } from "./header.vue?vue&type=template&id=6f4f389f&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=6f4f389f&lang=scss&scoped=true"

import exportComponent from "/Users/yue/Documents/其他项目/数字转创/official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4f389f"]])

export default __exports__